<ion-content class="background-white">
    <ion-grid class="ion-no-padding">
        <ion-row>
            <ion-col size="12" class="ion-no-padding">
                <div class="b-container modal2">
                    <div class="b-row header">
                        <div class="b-col-12">
                            {{ header }}
                        </div>
                    </div>
                    <div class="b-row">
                        <div class="b-col-12">
                            <div class="body">
                                <h2 class="b-mt-3">Confirm current password</h2>
                                <h3 class="" (click)="requestPasswordChange()">Forgot my password</h3>
                                <input [(ngModel)]="currentPassword" type="password" class="input" />

                                <h2 class="b-mt-3">New Password</h2>
                                <input [(ngModel)]="newPassword" type="password" class="input" (keyup)="recheckPassword()" />

                                <h2 class="b-mt-3">Confirm New Password</h2>
                                <input [(ngModel)]="newPasswordConfirm" type="password" class="input" />

                                <div class="check-icons">
                                    <div class="icon-holder">
                                        <fa-icon
                                            [icon]="faCheckCircle"
                                            [ngClass]="{ green: passwordGoodLength, red: passwordGoodLength === false }"
                                            size="medium"
                                        ></fa-icon>
                                        At least 8 characters long
                                    </div>
                                    <div class="icon-holder">
                                        <fa-icon
                                            [icon]="faCheckCircle"
                                            [ngClass]="{ green: passwordGoodLower, red: passwordGoodLower === false }"
                                            size="medium"
                                        ></fa-icon>
                                        One lowercase character
                                    </div>
                                    <div class="icon-holder">
                                        <fa-icon
                                            [icon]="faCheckCircle"
                                            [ngClass]="{ green: passwordGoodUpper, red: passwordGoodUpper === false }"
                                            size="medium"
                                        ></fa-icon>
                                        One uppercase character
                                    </div>
                                    <div class="icon-holder">
                                        <fa-icon
                                            [icon]="faCheckCircle"
                                            [ngClass]="{ green: passwordGoodSymbol, red: passwordGoodSymbol === false }"
                                            size="medium"
                                        ></fa-icon>
                                        One number or symbol
                                    </div>
                                </div>

                                <div class="footer-buttons">
                                    <div class="left">
                                        <ion-button
                                            class="left"
                                            fill="outline"
                                            color="secondary"
                                            size="medium"
                                            type="button"
                                            class="default-btn"
                                            (click)="dismiss()"
                                        >
                                            Cancel
                                        </ion-button>
                                    </div>

                                    <div class="right">
                                        <ion-button
                                            (click)="submit()"
                                            [disabled]="newPassword !== newPasswordConfirm"
                                            fill="solid"
                                            color="secondary"
                                            size="medium"
                                            type="button"
                                            class="default-btn"
                                        >
                                            Update
                                        </ion-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
